export default __webpack_public_path__ + "static/media/Blackice Band.9042c71f.jpg";